import { ExtensionOption } from 'src/app/pages/extension-register/models/extension-option.interface';
import { createEagerSelectActions } from '../../select/eager-select/eager-select-actions';

export const extensionOptionActions = createEagerSelectActions<ExtensionOption>('[Extension Options]');

export const extensionLoadAutoAttendantsActions = createEagerSelectActions<ExtensionOption>(
   '[Extension AutoAttendants Options]'
);

export const extensionLoadQueuesActions = createEagerSelectActions<ExtensionOption>('[Extension Queues Options]');

export const extensionLoadHuntGroupsActions = createEagerSelectActions<ExtensionOption>(
   '[Extension HuntGroup Options]'
);
